import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const HeadlineBoxStyled = styled.div`
    position: relative;
    display: flex;
    width: calc(100% - 60px);
    max-width: 338px;
    padding: 1.625rem 1.625rem 2rem 1.625rem;
    background-color: rgba(1, 1, 1, 0.9);
    font: 300 1.875rem ${(props) => props.theme.fonts[0]}, sans-serif;
    line-height: 2.25rem;
    color: #fff;
    box-sizing: border-box;

    img {
        position: absolute;
        right: -22px;
        bottom: -22px;
        width: 43px;
        height: 43px;

        @media screen and (min-width: 1024px) {
            right: -48px;
            bottom: 24px;
            width: 102px;
            height: 102px;
        }
    }

    @media screen and (min-width: 768px) {
        max-width: 548px;
        padding: 3rem 6.5265rem 3rem 3.125rem;
        font-size: 2.75rem;
        line-height: 3.75rem;
    }

    @media screen and (min-width: 1024px) {
        max-width: 848px;
        padding: 3rem 6.5265rem 3rem 3.125rem;
        font-size: 3.75rem;
        line-height: 4.375rem;
    }
`;

export default function HeadlineBox({ text, elementClass }) {
    return (
        <HeadlineBoxStyled className={elementClass && elementClass}>
            <p>{text}</p>
            <img
                src={require('../images/dot-grid.png')}
                width="102"
                height="102"
                alt="6x6 grid of small dots"
                title="6x6 grid of small dots"
            />
        </HeadlineBoxStyled>
    );
}

HeadlineBox.propTypes = {
    text: PropTypes.string.isRequired,
};
